module.exports = __webpack_public_path__ + "img/suzuki-ertiga-boostergreen.e8f5cef2.png";